"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAll = exports.parseFamiliarName = exports.parseQualifiedName = exports.parseQualifiedNameOptimized = void 0;
const regexp_1 = require("./regexp");
const digest_1 = require("./digest");
const reference_1 = require("./reference");
const NAME_MAX_LENGTH = 255;
class InvalidReferenceFormatError extends Error {
    constructor() {
        super("invalid reference format");
        this.name = "InvalidReferenceFormatError";
    }
}
class NameContainsUppercaseError extends Error {
    constructor() {
        super("repository name must be lowercase");
        this.name = "NameContainsUppercaseError";
    }
}
class EmptyNameError extends Error {
    constructor() {
        super("repository name must have at least one component");
        this.name = "EmptyNameError";
    }
}
class NameTooLongError extends Error {
    constructor() {
        super(`repository name must not be more than ${NAME_MAX_LENGTH} characters`);
        this.name = "NameTooLongError";
    }
}
const DEFAULT_DOMAIN = "docker.io";
const LEGACY_DEFAULT_DOMAIN = "index.docker.io";
const OFFICIAL_REPOSITORY_NAME = "library";
function _parseQualifiedName(regexp, name) {
    const matches = regexp.exec(name);
    if (!matches) {
        if (name === "") {
            throw new EmptyNameError();
        }
        if (regexp.test(name.toLowerCase())) {
            throw new NameContainsUppercaseError();
        }
        throw new InvalidReferenceFormatError();
    }
    if (matches[1].length > NAME_MAX_LENGTH) {
        throw new NameTooLongError();
    }
    let reference;
    const nameMatch = regexp_1.anchoredNameRegexp.exec(matches[1]);
    if (nameMatch && nameMatch.length === 3) {
        reference = {
            domain: nameMatch[1],
            repository: nameMatch[2],
        };
    }
    else {
        reference = {
            domain: "",
            repository: matches[1],
        };
    }
    reference.tag = matches[2];
    if (matches[3]) {
        (0, digest_1.validateDigest)(matches[3]);
        reference.digest = matches[3];
    }
    return new reference_1.Reference(reference);
}
const parseQualifiedNameOptimized = (name) => {
    return _parseQualifiedName(new RegExp(regexp_1.referenceRegexp), name);
};
exports.parseQualifiedNameOptimized = parseQualifiedNameOptimized;
const parseQualifiedName = (name) => {
    return _parseQualifiedName(regexp_1.referenceRegexp, name);
};
exports.parseQualifiedName = parseQualifiedName;
function splitDockerDomain(name) {
    let domain;
    let reminder;
    const indexOfSlash = name.indexOf("/");
    if (indexOfSlash === -1 ||
        !(name.lastIndexOf(".", indexOfSlash) !== -1 ||
            name.lastIndexOf(":", indexOfSlash) !== -1 ||
            name.startsWith("localhost/"))) {
        domain = DEFAULT_DOMAIN;
        reminder = name;
    }
    else {
        domain = name.substring(0, indexOfSlash);
        reminder = name.substring(indexOfSlash + 1);
    }
    if (domain === LEGACY_DEFAULT_DOMAIN) {
        domain = DEFAULT_DOMAIN;
    }
    if (domain === DEFAULT_DOMAIN && !reminder.includes("/")) {
        reminder = `${OFFICIAL_REPOSITORY_NAME}/${reminder}`;
    }
    return [domain, reminder];
}
const parseFamiliarName = (name, parseQualifiedNameFunc) => {
    if (regexp_1.anchoredIdentifierRegexp.test(name)) {
        throw new TypeError(`invalid repository name (${name}),` +
            `cannot specify 64-byte hexadecimal strings`);
    }
    const [domain, remainder] = splitDockerDomain(name);
    let remoteName;
    const tagSeparatorIndex = remainder.indexOf(":");
    if (tagSeparatorIndex > -1) {
        remoteName = remainder.substring(0, tagSeparatorIndex);
    }
    else {
        remoteName = remainder;
    }
    if (remoteName.toLowerCase() !== remoteName) {
        throw new TypeError(`invalid reference format: repository name must be lowercase`);
    }
    if (parseQualifiedNameFunc) {
        return parseQualifiedNameFunc(`${domain}/${remainder}`);
    }
    return parseQualifiedName(`${domain}/${remainder}`);
};
exports.parseFamiliarName = parseFamiliarName;
const parseAll = (name) => {
    if (regexp_1.anchoredIdentifierRegexp.test(name)) {
        return new reference_1.Reference({ digest: `sha256:${name}` });
    }
    if ((0, digest_1.isDigest)(name)) {
        return new reference_1.Reference({ digest: name });
    }
    return parseFamiliarName(name);
};
exports.parseAll = parseAll;
//# sourceMappingURL=parsers.js.map